export class ShowByTimeAndIdSector{
    constructor(repository){
        this.repository=repository
    }

    async execute(FK_SECTOR,TIME){
        const resp= await this.repository.getSectorByTimeAndIdSector(FK_SECTOR,TIME)
        return resp
    }
}